import { render, staticRenderFns } from "./salesReview.vue?vue&type=template&id=1b6ded9b"
import script from "./salesReview.vue?vue&type=script&lang=js"
export * from "./salesReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports